import { storefrontApi } from "@app/lib/storefrontApi";
import Cookies from "js-cookie";

export const updateCustomer = async (customerFields: {
  acceptsMarketing?: boolean;
  email?: string;
  firstName?: string;
  lastName?: string;
  password?: string;
  phone?: string;
}) => {
  try {
    const customerAccessToken = Cookies.get("customerAccessToken");
    const { customerUpdate } = await storefrontApi(
      `mutation customerUpdate($customer: CustomerUpdateInput!, $customerAccessToken: String!) {
        customerUpdate(customer: $customer, customerAccessToken: $customerAccessToken) {
          customerAccessToken {
            accessToken
          }
          customerUserErrors {
            field
            message
          }
        }
      }`,
      {
        customer: customerFields,
        customerAccessToken,
      },
    );
    return customerUpdate;
  } catch (error) {
    console.log("[ERROR] updateCustomer:", error);
  }
};

export const createAddress = async (address: {
  address1: string;
  city: string;
  company?: string;
  country: string;
  firstName: string;
  lastName: string;
  province: string;
  zip: string;
}) => {
  try {
    const customerAccessToken = Cookies.get("customerAccessToken");
    const res = await storefrontApi(
      `mutation customerAddressCreate($address: MailingAddressInput!, $customerAccessToken: String!) {
        customerAddressCreate(address: $address, customerAccessToken: $customerAccessToken) {
          customerAddress {
            id
          }
          customerUserErrors {
            field
            message
          }
        }
      }`,
      {
        address,
        customerAccessToken,
      },
    );
    return res?.customerAddressCreate || {};
  } catch (error) {
    console.log("[ERROR] createAddress:", error);
  }
};

export const updateAddress = async (
  id: string,
  address: {
    address1?: string;
    city?: string;
    company?: string;
    country?: string;
    firstName?: string;
    lastName?: string;
    province?: string;
    zip?: string;
  },
) => {
  try {
    const customerAccessToken = Cookies.get("customerAccessToken");
    const res = await storefrontApi(
      `mutation customerAddressUpdate($address: MailingAddressInput!, $customerAccessToken: String!, $id: ID!) {
        customerAddressUpdate(address: $address, customerAccessToken: $customerAccessToken, id: $id) {
          customerAddress {
            id
          }
          customerUserErrors {
            field
            message
          }
        }
      }`,
      {
        id,
        address,
        customerAccessToken,
      },
    );
    return res?.customerAddressUpdate || {};
  } catch (error) {
    console.log("[ERROR] createAddress:", error);
  }
};

export const deleteAddress = async (id: string) => {
  try {
    const customerAccessToken = Cookies.get("customerAccessToken");
    const res = await storefrontApi(
      `mutation customerAddressDelete($customerAccessToken: String!, $id: ID!) {
        customerAddressDelete(customerAccessToken: $customerAccessToken, id: $id) {
          customerUserErrors {
            field
            message
          }
        }
      }`,
      {
        id,
        customerAccessToken,
      },
    );
    return res?.customerAddressDelete || {};
  } catch (error) {
    console.log("[ERROR] createAddress:", error);
  }
};

export const updateDefaultAddress = async (addressId: string) => {
  try {
    const customerAccessToken = Cookies.get("customerAccessToken");
    const res = await storefrontApi(
      `mutation customerDefaultAddressUpdate($addressId: ID!, $customerAccessToken: String!) {
        customerDefaultAddressUpdate(addressId: $addressId, customerAccessToken: $customerAccessToken) {
          customerUserErrors {
            field
            message
          }
        }
      }`,
      {
        addressId,
        customerAccessToken,
      },
    );
    return res?.customerDefaultAddressUpdate || {};
  } catch (error) {
    console.log("[ERROR] updateDefaultAddress:", error);
  }
};
